import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "../core/services/user.service";

@Injectable({
  providedIn: "root",
})
export class InternalAuthGuardService implements CanActivate {
  constructor(
    private user: UserService,
    private router: Router
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.user.requestedRoute = state.url;

    await this.user.waitForAuthReady();

    const fbUser = await this.user.afAuth.currentUser;
    if (!fbUser) {
      return this.router.createUrlTree(["/login"], {
        queryParams: { returnUrl: state.url },
      });
    }

    const ok = await this.user.ensureLoggedInUserLoaded(fbUser.uid);
    if (!ok) {
      return this.router.createUrlTree(["/login"], {
        queryParams: { returnUrl: state.url },
      });
    }

    this.user.refreshRequestedRoute = state.url;
    return true;
  }
}